import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/Home/Home.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Home/sections/Banner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Home/sections/KaufClever.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/Audi.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/BMW.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/Ford.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/LandRover.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/Mercedes-Benz.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/Porsche.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/Renault.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/Volkswagen.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/Volvo.avif");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/landing/auctionedCar.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/landing/car_pricing.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/landing/car_with_swoosh.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/landing/Gebot_abgeben.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/landing/man_holding_docs.png");
